import { type ReactNode, useCallback, useMemo, useState } from "react";

import { ProjectModalsContext } from "./hooks";
import { renderModalDetails } from "./renderModalDetails";
import { type ModalDefinition } from "./types";

interface Props {
  children: ReactNode;
}

export const ModalsProvider = ({ children }: Props) => {
  const [modals, setModals] = useState<ModalDefinition[]>([]);

  const pushModal = useCallback(
    (newModal: ModalDefinition, reset?: boolean) => {
      setModals((prev) => (reset ? [newModal] : [...prev, newModal]));
    },
    []
  );

  const hideModal = useCallback((modalType: ModalDefinition["type"]) => {
    setModals((prev) => prev.filter((el) => el.type !== modalType));
  }, []);

  const state = useMemo(
    () => ({ modals, pushModal, hideModal }),
    [modals, pushModal, hideModal]
  );

  return (
    <ProjectModalsContext.Provider value={state}>
      {children}
      {modals?.map((modal) => (
        <div key={modal.type}>{renderModalDetails(modal, hideModal)}</div>
      ))}
    </ProjectModalsContext.Provider>
  );
};
